import { baseApi } from "./baseApi";

const surveyApi: any = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSurveys: builder.query({
      query: (params) => {
        let url = "surveys";

        url += "?";

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }

        if (params.status) {
          url += `status=${params.status}&`;
        }
        if (params.brand_id) {
          url += `brand_id=${params.brand_id}&`;
        }
        if (params.city_id) {
          url += `city_id=${params.city_id}&`;
        }
        if (params.contact_number) {
          url += `contact_number=${params.contact_number}&`;
        }
        if (params.customer_name) {
          url += `customer_name=${params.customer_name}&`;
        }
        if (params.assigned_city_manager_id) {
          url += `assigned_city_manager_id=${params.assigned_city_manager_id}&`;
        }
        if (params.zone_id) {
          url += `zone_id=${params.zone_id}&`;
        }
        if (params.partner_id) {
          url += `partner_id=${params.partner_id}&`;
        }
        if (params.agent_id) {
          url += `agent_id=${params.agent_id}&`;
        }
        if (params.brand_booking_code) {
          url += `brand_booking_code=${params.brand_booking_code}&`;
        }
        if (params.brand_booking_status) {
          url += `brand_booking_status=${params.brand_booking_status}&`;
        }
        if (params.ecb_code) {
          url += `ecb_code=${params.ecb_code}&`;
        }
        if (params.start_date) {
          url += `start_date=${params.start_date}&`;
        }
        if (params.end_date) {
          url += `end_date=${params.end_date}&`;
        }
        if (params.next_follow_up_start) {
          url += `next_follow_up_start=${params.next_follow_up_start}&`;
        }
        if (params.next_follow_up_end) {
          url += `next_follow_up_end=${params.next_follow_up_end}&`;
        }
        if (params.start_approved_at) {
          url += `start_approved_at=${params.start_approved_at}&`;
        }
        if (params.end_approved_at) {
          url += `end_approved_at=${params.end_approved_at}&`;
        }
        if (params.state_id) {
          url += `state_id=${params.state_id}&`;
        }
        if (params.unassigned) {
          url += "unassigned=true&";
        }

        if (params.unassigned === false) {
          url += "unassigned=false&";
        }

        if (params.payment_received) {
          url += "payment_received=true&";
        }
        if (params.payment_received === false) {
          url += "payment_received=false&";
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }
        return url;
      }
    }),
    getSurveyById: builder.query({
      query: (id) => `surveys/${id}`
    }),
    createSurvey: builder.mutation({
      query: (data) => ({
        url: "surveys",
        method: "POST",
        body: data
      })
    }),
    updateSurvey: builder.mutation({
      query: (data) => ({
        url: `surveys/${data?.id}`,
        method: "PUT",
        body: data
      })
    }),
    // {{Server}}/api/v1/surveys/84/cancel?reason=CustomerRefused
    cancelSurvey: builder.mutation({
      query: (data) => ({
        url: `surveys/${data?.id}/cancel?reason=${data?.reason}`,
        method: "PUT"
      })
    }),
    // {{Server}}/api/v1/surveys/84/on_hold?reason=DealerRequest
    onHoldSurvey: builder.mutation({
      query: (data) => ({
        url: `surveys/${data?.id}/on_hold?reason=${data?.reason}`,
        method: "PUT"
      })
    }),

    deleteSurvey: builder.mutation({
      query: (id) => ({
        url: `surveys/${id}`,
        method: "DELETE"
      })
    }),
    createCustomerConnectLogForSurvey: builder.mutation({
      query: (data) => ({
        url: `surveys/${data?.id}/add_customer_connect_log`,
        method: "POST",
        body: data
      })
    }),
    updateCustomerConnectLogForSurvey: builder.mutation({
      query: (data) => ({
        url: `surveys/${data?.id}/edit_customer_connect_log`,
        method: "PUT",
        body: data
      })
    }),
    generatePaymentLink: builder.mutation({
      query: (id) => ({
        url: `surveys/${id}/generate_payment_link`,
        method: "POST"
      })
    }),
    getCustomerConnectLogsForSurvey: builder.query({
      query: (id) => ({
        url: `surveys/${id}/customer_connect_logs`,
        method: "GET"
      })
    }),
    getPaymentsForSurvey: builder.query({
      query: (id) => ({
        url: `surveys/${id}/payments`,
        method: "GET"
      })
    }),
    getRefundsForSurvey: builder.query({
      query: (id) => ({
        url: `surveys/${id}/refunds`,
        method: "GET"
      })
    })
  })
});

export const {
  useGetSurveysQuery,
  useLazyGetSurveyByIdQuery,
  useCreateSurveyMutation,
  useUpdateSurveyMutation,
  useDeleteSurveyMutation,
  useCancelSurveyMutation,
  useOnHoldSurveyMutation,
  useCreateCustomerConnectLogForSurveyMutation,
  useUpdateCustomerConnectLogForSurveyMutation,
  useGeneratePaymentLinkMutation,
  useGetCustomerConnectLogsForSurveyQuery,
  useGetPaymentsForSurveyQuery,
  useGetRefundsForSurveyQuery
} = surveyApi;
